import React from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import DateFilterBase from './DateFilterBase';
import { selectFilter, setToDate } from './filterSlice';

interface Props {
  placeholder: string | null;
  showFormat: boolean;
}

export default function DateFilterTo(props: Props) {
  const { placeholder, showFormat } = props;
  const filter = useAppSelector(selectFilter);
  const dispatch = useAppDispatch();
  const handleChange = React.useCallback(
    (date: unknown) => {
      if ((date as any)?.toString() === 'Invalid Date') {
        return;
      }
      dispatch(setToDate((date as Date)?.getTime() ?? -1));
    },
    [dispatch],
  );
  return (
    <DateFilterBase
      showFormat={!showFormat}
      label={placeholder ?? 'Any Date'}
      value={filter.dateRange.to === -1 ? null : new Date(filter.dateRange.to)}
      handleChange={handleChange}
    />
  );
}
